import { Component, OnInit } from '@angular/core';
import { LoggerService, ViewDataService, LoggedComponent, SeriesItemLocator, SeriesStagesItem, SeriesItem, IFilterComboComponent, SeriesStageLocator } from 'world-archery-lib';
import { FilterWCupRankingService } from '../../services/filter-wcup-ranking.service';
import { first, filter, tap, switchMap } from 'rxjs/operators';
import { ThrowStmt } from '@angular/compiler';

@Component({
  selector: 'app-wcup-series-panel',
  templateUrl: './wcup-series-panel.component.html',
  styleUrls: ['./wcup-series-panel.component.scss']
})
export class WcupSeriesPanelComponent extends LoggedComponent implements OnInit {
  series: SeriesItem;
  seriesStage: Array<SeriesStagesItem> = [];
  constructor(
    protected logger: LoggerService,
    protected views: ViewDataService,
    public filter_service: FilterWCupRankingService
  ) {
    super(logger);
  }
  getDataStream() {
  }
  ngOnInit() {

    (<IFilterComboComponent>(
      this.filter_service.filtersType[3].options
    )).options_selected_subject
      .asObservable()
      .pipe(
        filter(year => year !== undefined),
        tap(a => this.series = a),
        switchMap(a => {
          const seriesLocator = new SeriesStageLocator();
          seriesLocator.discipline.id = seriesLocator.discipline.outdoorCode;
          seriesLocator.year.value = a.year;

          return this.views.get(seriesLocator).getDataStream();
        }),
      ).subscribe(next => this.seriesStage = next)


  }

}
